import React from 'react';

function TeamDropdown({
  user,
  navigate,
  onClose,
  submenuItemStyles
}) {

  const handleTeamDashboardClick = () => {
    if (user?.agentur_id && user?.a_team_id) {
      navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/dashboard`);
    } else if (user?.team?.id) {
      navigate(`/team-leads/${user.team.id}?name=${encodeURIComponent(user.team.name || 'Mein Team')}`);
    } else {
      navigate('/organization-management');
    }
    onClose();
  };

  const handleTeamViewClick = () => {
    navigate('/organization-management');
    onClose();
  };

  const handleTeamLeadsClick = () => {
    if (user?.team?.id) {
      navigate(`/team-leads/${user.team.id}?name=${encodeURIComponent(user.team.name || 'Mein Team')}`);
    } else {
      console.error('No team ID found for user');
      alert('Kein Team gefunden. Bitte kontaktieren Sie den Administrator.');
    }
    onClose();
  };

  const handleAddUserClick = () => {
    if (user?.team?.id) {
      navigate(`/create-user?teamId=${user.team.id}`);
    } else {
      navigate('/create-user');
    }
    onClose();
  };

  const menuItemStyle = {
    ...submenuItemStyles,
    justifyContent: 'flex-start'
  };

  const dashboardItemStyle = {
    ...menuItemStyle,
    fontWeight: '600'
  };

  const separatorStyle = {
    height: '1px',
    backgroundColor: '#e2e8f0',
    margin: '4px 0'
  };

  return (
    <>
      {/* Team Dashboard - Hervorgehoben */}
      <button 
        style={dashboardItemStyle}
        onClick={handleTeamDashboardClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        📊 Team Dashboard
      </button>

      {/* Trennlinie */}
      <div style={separatorStyle}></div>

      {/* Team verwalten */}
      <button 
        style={menuItemStyle}
        onClick={handleTeamViewClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        👥 Team verwalten
      </button>
      
      {/* Team-Leads ansehen */}
      <button 
        style={menuItemStyle}
        onClick={handleTeamLeadsClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        📋 Team-Leads ansehen
      </button>
      
      {/* Benutzer zum Team hinzufügen */}
      <button 
        style={menuItemStyle}
        onClick={handleAddUserClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        ➕ Benutzer zum Team hinzufügen
      </button>
    </>
  );
}

export default TeamDropdown;